import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
const CameraLocationsDB = [

    {
        cameraLocationId: 'W01HOP01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Phiona Richards',
        cameraPosition: new Vector3(-4.640, 1.500, 11.426), // use THREE.Vector3
        cameraRotation: new Euler(0.000, 1.309, 0.000),  //use THREE.Euler
    },
    {
        cameraLocationId: 'W01HOP02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Linzi Bright',
        cameraPosition: new Vector3(-4.755, 1.500, 7.333),
        cameraRotation: new Euler(-0.651, 1.495, 0.650),
    },

    {
        cameraLocationId: 'W01HOP03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Caroline Miles',
        cameraPosition: new Vector3(-5.864, 1.500, 2.928),
        cameraRotation: new Euler(-0.391, 1.450, 0.389),
    },
    {
        cameraLocationId: 'W01HOP05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Entrance',
        cameraPosition: new Vector3(-5.068 , 1.5, 19.185),
        cameraRotation: new Euler(0, .568, 0),
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
